
interface QuoteSupportEndpoints{ 
    email: string,
    findToken: string,
    restore: string,
    payOffline: string,
    paymentAuthorise: string,
    paymentInitiate: string,
    saveAndExit: (string | { [key:string]:string }),
    [others: string]: any
}


interface QuoteSupportConfig{
    endpoints: QuoteSupportEndpoints,
    [others: string]: any
}


export default function(config:QuoteSupportConfig){

    const initialState = {
        endpoints: config.endpoints
    }


    return function(state = initialState, action){

        switch(action.type){
            default: return state
        }

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/quote-support/quote-support-reducer.ts